import {
  ActionPattern,
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects'
import { Saga } from 'redux-saga'

import ApiSagas from '../api/sagas'
import { actions, selectors } from '..'
import {
  plans,
  reducedCurrentPlan,
  currentPlan,
  fullPlans,
  userPlanById,
} from '../../graphql/Services/User/queries'
import { ServiceRequestAction } from '../../helpers/ReduxHelpers'
import Router from '../../routes/router'
import routes from '../../routes/definitions'

export default class PlanSagas {
  static *init() {
    yield
    return
  }

  static *loadReducedCurrentPlan() {
    const results = yield call(ApiSagas.query, reducedCurrentPlan())
    if (results?.data) {
      yield put(actions.user.setCurrentPlan(results?.data))
    } else {
      yield put(actions.user.setCurrentPlan(null))
    }
  }

  static *loadCurrentPlan() {
    const results = yield call(ApiSagas.query, currentPlan())
    if (results?.data) {
      console.log('Current plan found')
      yield put(actions.user.setCurrentPlan(results?.data))
    } else if (results?.errors) {
      console.log(
        'Error loading current plan, regenerate current plan',
        results?.errors
      )
      yield put(actions.app.setIsLoading(false))
      yield put(actions.user.setIsGeneratingPlanning(false))
      Router.pushRoute(routes.regenerate.name)
    } else {
      console.log('No current plan found')
      yield put(actions.user.setCurrentPlan(null))
    }
  }

  static *loadPlans(page = 1) {
    const currentPlans = yield select(selectors.user.plans)
    const results = yield call(
      ApiSagas.query,
      plans({
        first: 5,
        page,
      })
    )
    yield put(
      actions.user.setPlans(
        currentPlans
          ? [...currentPlans, ...results?.data?.plans?.data].filter(
              (plan, index, self) =>
                index === self.findIndex((p) => p.id === plan.id)
            )
          : results?.data?.plans?.data
      )
    )
    yield put(
      actions.planninghistory.setHasMorePages(
        results?.data?.plans?.paginatorInfo?.hasMorePages
      )
    )
  }

  static *loadPlan(action: ServiceRequestAction) {
    const { payload } = action
    const results = yield call(ApiSagas.query, userPlanById({ id: payload.id }))
    if (results?.data) {
      yield put(actions.user.setPlans([results?.data]))
    } else {
      yield put(actions.user.setPlans([]))
    }
  }

  static *loadFullPlans(page = 1) {
    const results = yield call(
      ApiSagas.query,
      fullPlans({
        first: 50,
        page,
      })
    )
    yield put(actions.user.setPlans(results?.data?.plans?.data))
  }

  static *loop() {
    yield all([
      takeLatest(actions.plan.loadPlan as ActionPattern, this.loadPlan as Saga),
    ])
  }
}
